module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"changePlan":"Отказаться от подписки, а также изменить платёжный период вы можете в разделе","changePlanLink":"Ваш тариф"}}')
  delete Component.options._Ctor
}
